/* eslint-disable react-hooks/exhaustive-deps */
import ChatList from "../chatList/ChatList";
import ChatContent from "../chatContent/ChatContent";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loader } from "graphql.macro";
import {
  deleteMessagesById,
  updateConversations,
  updateCustomerDetails,
  updateInitialState,
  updateMessagesById,
  updateParticipants,
} from "../../store/action-creators/conversationActionCreator";
import fetchConversations, {
  fetchConversationById,
  fetchMessagesById,
  fetchParticipants,
  fetchUnreadMessagesCountById,
  formatSelectedConversation,
  updateArchiveConversation,
  updatePinConversation,
  updateReadMessages,
} from "../../store/actions/conversationActions";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import {
  checkAllParamsRequestedFromCC,
  checkAndUpdateConversationListFromNewMessage,
  formatNewLinesInHtml,
  formatPhoneNumber,
  getPinnedConversations,
  getUpdatedMessages,
  handleLoader,
  handleSubscriptionError,
  isActiveParticipant,
  isNotEmpty,
  setAlert,
  simpleGTMDataLayer,
  twoStringsAreEqual,
  updateConversationsOrder,
  updateConversationsOrderCC,
} from "../../utils/utilities";
import {
  CUSTOMER,
  NEW,
  NO_CONVERSATION_ERROR,
  RECEIVED,
  SEND,
  SNACKBAR,
} from "../../utils/constants";
import { executeGraphqlSubscribe } from "../../graphql/api";

import "./Conversation.css";
import { SAPopover } from "@saux/design-system-react";
import claimSearch from "../../store/actions/claimsSearchActions";

const receiveMessagesSubscription = loader(
  "../../graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);

function Conversation(props: any) {
  // const [notificationSoundValue] = useGlobalState("notificationSound")
  const [referenceElement, setReferenceElement] = useState<Element | null>(
    null
  );
  const [newMessage, setNewMessage] = useState({
    message: "",
    from: { id: "", name: "" },
    createdTime: "",
    conversationId: "",
    adjusterId: "",
  });
  const [animationClasses, setAnimationClasses] = useState("slide-right");
  const chat = useSelector((state: any) => state.chat);
  let {
    unreadMsgCount,
    messagesById: messages,
    selectedConversation: selected_conversation,
    allConversations: conversations,
  } = chat;
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let messageSubscription: any;
  
  useEffect(() => {
    subscribeToMessage();
    handleLoader(true);
    //fetching all existing conversations using pagination
    dispatch(
      fetchConversations(
        { adjusterId: user?.email, isArchived: false },
        (res: any) => {
        if (res.length > 0) {
          let id = query.get('id');
          const sessionResponse = sessionStorage.getItem(user.email);
          sessionStorage.removeItem(user.email);
          let response: any = JSON.parse(sessionResponse || "{}");
          let requestedConversation = (res || []).find(
            (con: any) => con.conversationId === id
          );
          if (id && requestedConversation) {
            let conversations = (res || []).filter(
              (con: any) => con.conversationId !== id
            );
            updateConversationsOrderCC(requestedConversation);
            dispatch(formatSelectedConversation(requestedConversation));
          }
          else if (id && Object.keys(response).length !== 0) {
            updateConversationsOrderCC(response);
            dispatch(formatSelectedConversation(response));
          } 
          else{
            dispatch(formatSelectedConversation(res[0]));
            dispatch(fetchMessagesById(res[0].conversationId));
          }
        
          }
          requestFromExternal(res);
        },
        (error: any) => {
          //error
          handleLoader(false);
          dispatch(
            snackbarOpen({
              open: true,
              message: error.message,
              type: SNACKBAR.ERROR,
            })
          );
        }
      )
    );
    simpleGTMDataLayer({
      csrId: user.userName,
      event: "pageview",
      page: {
        path: "/message",
        title: "Claims Texting: Conversation Page",
      },
    });

    return () => componentWillUnmount();
  }, []);

  useEffect(() => {
    if (newMessage.message) {
      console.log(newMessage)
      let newMsgDetails: any = {type:"",conversationId:"",fromId:""};
      let updatedNewMessage:any={};
      if (messages[newMessage.conversationId]) {
        let updatedMessages = getUpdatedMessages(newMessage);
         updatedNewMessage = {
          ...newMessage,
          type: twoStringsAreEqual(user.email, newMessage.from.id)
            ? SEND
            : RECEIVED,
        };
        newMsgDetails = {
          type:updatedNewMessage.type,
          conversationId:newMessage.conversationId,
          fromId:newMessage.from.id
        };
        dispatch(
          updateMessagesById({
            ...messages,
            [newMessage.conversationId]: [
              ...updatedMessages,
              updatedNewMessage
            ]
          })
        );
      }
      if (messages[NEW]) {
        delete messages[NEW];
        dispatch(deleteMessagesById(messages));
      }
      if (isActiveParticipant(newMessage.conversationId, user.email)) {
        dispatch(fetchUnreadMessagesCountById(newMessage.conversationId));
        updateConversationsOrder(newMessage.conversationId);
        setAlert(newMsgDetails);
      } else {
        dispatch(
          updateReadMessages({
            conversationId: newMessage.conversationId,
            adjusterId: user.email,
          })
        );
      }
    }
  }, [newMessage]);

  // Subscribeing messages using adjusterID
  const subscribeToMessage = () => {
    messageSubscription = executeGraphqlSubscribe(
      receiveMessagesSubscription
    ).subscribe({
      next: ({ provider, value }: any) => {
        let messageResponse = value?.data?.onCreateMessageByAdjusterId;
        //Sending to store only if user is a part of that conversation.
        if ((messageResponse?.adjusterIds || []).includes(user.email)) {
          messageResponse = {
            ...messageResponse,
            message: formatNewLinesInHtml(messageResponse.message),
          };
          setNewMessage(messageResponse);
          checkAndUpdateConversationListFromNewMessage(
            messageResponse,
            user.email
          );
        }
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };

  const componentWillUnmount = () => {
    if (selected_conversation?.conversationId === NEW) {
      let updatedConversations = conversations.filter(
        (item: any) => item.conversationId !== NEW
      );
      dispatch(updateConversations([...updatedConversations]));
    } else if (selected_conversation?.conversationId) {
      dispatch(
        updateReadMessages({
          conversationId: selected_conversation.conversationId,
          adjusterId: user.email,
        })
      );
    }
    dispatch(updateInitialState());
    sessionStorage.removeItem('newConvoCutomer');
    messageSubscription.unsubscribe();
  };

  useEffect(() => {
    if (
      isNotEmpty(selected_conversation) &&
      selected_conversation.conversationId === NEW
    ) {
      history(`/message`);
    } else if (isNotEmpty(selected_conversation)) {
      history(`/message?id=${selected_conversation.conversationId}`);
      if (!messages[selected_conversation.conversationId]) {
        dispatch(fetchMessagesById(selected_conversation.conversationId));
      }
    }
  }, [selected_conversation]);

  const checkCustomerPhNumber = (phoneNumber: any, participants: any) => {
    return participants.find((item: any) => item.phoneNumber === phoneNumber)
      ? true
      : false;
  };

  const checkRequestedClaimHasConversation = (
    conversation: any,
    isExternal: boolean = true,
    existingConversations: any
  ) => {
    let index = (existingConversations || []).findIndex(
      (item: any) =>
        item.claimNumber === conversation.claimNumber &&
        checkCustomerPhNumber(
          conversation.participants[0].phoneNumber,
          item.participants
        )
    );
    // If the requested Conversation already exists in store.

    if (index !== -1) {
      dispatch(formatSelectedConversation(existingConversations[index]));
      updateConversationsOrder(existingConversations[index].conversationId);
      handleLoader(false);
    } else {
      fetchConversationById(
        {
          claimNumber: conversation.claimNumber,
          phoneNumber: conversation.participants[0].phoneNumber,
        },
        user.email,
        (res: any) => {
          if (res && res.archiveStatus) {
            const var_data = JSON.stringify(res);
            sessionStorage.setItem(user.email, var_data);
            sessionStorage.setItem('archiveConversation', res.conversationId)
            history(
              `/archived-conversations?id=${res.conversationId}`
            );
          }
          // Already requested Conversation exists in database
          else if (res) {
            updateConversationsOrderCC(res);
            dispatch(formatSelectedConversation(res));
          }

          // if the requested conversation is from Claim Center and it is not created.
          else if (isExternal) {
            const pinnedConversations = getPinnedConversations();
            dispatch(formatSelectedConversation(conversation));
            dispatch(
              updateConversations([
                ...pinnedConversations,
                conversation,
                ...existingConversations?.slice(pinnedConversations.length),
              ])
            );
            
          }

          // Requested conversation is not from Claim Center and not exists in DB
          else {
            existingConversations &&
              dispatch(formatSelectedConversation(existingConversations[0]));
            dispatch(
              snackbarOpen({
                open: true,
                message: NO_CONVERSATION_ERROR,
                type: SNACKBAR.ERROR,
              })
            );
          }
          handleLoader(false);
        },
        (error: any) => {
          handleLoader(false);
          dispatch(
            snackbarOpen({
              open: true,
              message: error.message,
              type: SNACKBAR.ERROR,
            })
          );
        }
      );
    }
  };


  const requestFromExternal = async (conversations: any) => {
    let query = new URLSearchParams(location.search);
    let params: any = {};
    query.forEach((k, v) => {
      params[v] = k;
    });
    
    if (isNotEmpty(params)) {
      if (checkAllParamsRequestedFromCC(params)) {
        let lossdate:any = await getLossDate(params.claimNumber);
        const conversation = {
          adjusterId: params.adjusterId,
          claimNumber: params.claimNumber,
          conversationId: NEW,
          textNumber: formatPhoneNumber(params.textNumber),
          env: params.env,
          uwCompany: params.uwCompany,
          participants: [
            {
              name: params.customerName,
              phoneNumber: formatPhoneNumber(params.phoneNumber),
              participantType: CUSTOMER,
              contactId: params.contactId
            },
          ],
        };

        const customer = {
          firstName: params.firstName,
          lastName: params.lastName,
          mobileNumber: formatPhoneNumber(params.phoneNumber),
          lossDate: lossdate
        }
        if('firstName' in params && 'lastName' in params){
            const cust_data = JSON.stringify(customer);
            sessionStorage.setItem('newConvoCutomer', cust_data);
            //Update customer details for external record.
            dispatch(updateCustomerDetails(customer));
        }
        checkRequestedClaimHasConversation(conversation, true, conversations);
      }
      // When user search based on Conversation Id.
      else if (params["id"]) {
        let existingConversation = (conversations || []).find(
          (con: any) => con.conversationId === params["id"]
        );
        if (existingConversation) {
          dispatch(formatSelectedConversation(existingConversation));
          handleLoader(false);
        } else {
          fetchConversationById(
            { conversationId: params["id"] },
            user.email,
            (res: any) => {
              if (res) {
                dispatch(formatSelectedConversation(res));
                const pinnedConversations = getPinnedConversations();
                dispatch(
                  updateConversations([
                    ...pinnedConversations,
                    res,
                    ...conversations?.slice(pinnedConversations.length),
                  ])
                );
              }
              handleLoader(false);
            },
            (error: any) => {
              handleLoader(false);
              dispatch(
                snackbarOpen({
                  open: true,
                  message: error.message,
                  type: SNACKBAR.ERROR,
                })
              );
            }
          );
        }
      }
      // If both are failed then it's invalid url
      else {
        handleLoader(false);
        dispatch(
          snackbarOpen({
            open: true,
            message: "Invalid URL",
            type: SNACKBAR.ERROR,
          })
        );
      }
    } else {
      handleLoader(false);
    }
  };

  const getLossDate = (claimNumber: any) => {
    let lossdate: any;
    //get lossdate
    return new Promise((resolve, reject) => {
    claimSearch({ query: claimNumber })
      .then((res: any) => {
        if(res.data.searchClaims.length !=0){
          lossdate = res.data.searchClaims.find(
            (obj: any) => obj.claim_number == claimNumber
          ).loss_date;
          
        }
        resolve(lossdate) ;
      }).catch((err) => {
        console.log(err);
      });
    });
  }


  function handleClose(
    event: React.MouseEvent<HTMLElement> | MouseEvent,
    index: number | null
  ) {
    setReferenceElement(null);
    if (index === 0) {
      if (
        getPinnedConversations().length >= 3 &&
        !selected_conversation.pinStatus
      ) {
        dispatch(
          snackbarOpen({
            open: true,
            message:
              "3 pin conversation limit, to pin this conversation, unpin another one first",
            type: SNACKBAR.ERROR,
          })
        );
        return;
      }
      dispatch(
        updatePinConversation({
          conversationId: selected_conversation.conversationId,
          adjusterId: user.email,
          pin: !selected_conversation.pinStatus,
          participantName: user.fullName,
        })
      );
      let label = selected_conversation.pinStatus ? "Unpin" : "Pin";
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `${label}ned-Conversation-Click`,
        event_action: "Button Click",
        event_category: window.location.pathname,
        event_label: `${label}ning a conversation`,
        event_value: `${user.fullName} ${label}ned conversation with claim number ${selected_conversation.claimNumber}.`,
        claim_number: selected_conversation.claimNumber,
      });
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `${label}ned-Conversation-Click-Snowplow`,
        event_action: "Button Click",
        event_category: window.location.pathname + "/Snowplow",
        event_label: `${label}ning a conversation`,
        event_value: `${user.fullName} ${label}ned conversation with claim number ${selected_conversation.claimNumber}.`,
        claim_number: selected_conversation.claimNumber,
      });
    } else if (index === 1) {
      dispatch(
        updateArchiveConversation({
          conversationId: selected_conversation.conversationId,
          adjusterId: user.email,
          archive: true,
        })
      );
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Archived-Conversation-Click`,
        event_action: "Button Click",
        event_category: window.location.pathname,
        event_label: `Making conversation Archive`,
        event_value: `${user.fullName} archived conversation with claim number ${selected_conversation.claimNumber}.`,
        claim_number: selected_conversation.claimNumber,
      });
      simpleGTMDataLayer({
        csrId: user.userName,
        event: `Archived-Conversation-Click-Snowplow`,
        event_action: "Button Click",
        event_category: window.location.pathname + "/Snowplow",
        event_label: `Making conversation Archive`,
        event_value: `${user.fullName} archived conversation with claim number ${selected_conversation.claimNumber}.`,
        claim_number: selected_conversation.claimNumber,
      });
    }
  }

  const toggleAnimation = () => {
    setAnimationClasses(
      animationClasses === "slide-right" ? "slide-left" : "slide-right"
    );
  };

  return (
    <div data-testid="conversation">
      <div className="chat-box">
        <ChatList
          toggleAnimation={toggleAnimation}
          receivedConversationsCount={props.receivedConversationsCount}
          setReferenceElement={setReferenceElement}
          className={animationClasses}
          menuOptions={true}
        />
        <ChatContent toggleAnimation={toggleAnimation} location={location.search} />
        <SAPopover
          data={[
            selected_conversation?.pinStatus
              ? "Unpin Conversation"
              : "Pin Conversation",
            "Archive Conversation",
          ]}
          onClose={(e: MouseEvent, index: number | null) =>
            handleClose(e, index)
          }
          placement="right"
          referenceElement={referenceElement}
          variant="popover-menu"
        />
      </div>
    </div>
  );
}

export default Conversation;